<template>
  <section
    v-if="variants.v1 === variant && sidebarComponents.length === 0"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-between md:tw-flex-row md:tw-items-center">
      <div
        class="tw-flex tw-flex-wrap tw-justify-center tw-text-center tw-text-black lg:tw-gap-4"
        v-html="vars.titleHtml"
      ></div>
      <div class="tw-hidden lg:tw-block">
        <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">{{
          vars.buttonLabelText
        }}</nuxt-link>
      </div>
    </div>
    <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-gap-10 tw-pt-10 lg:tw-flex-col-reverse">
      <Swiper
        :modules="[SwiperPagination]"
        :pagination="false"
        :slides-per-view="1"
        :space-between="10"
        effect="fade"
        :loop="true"
        :clickable="true"
        :watch-overflow="true"
        @slideChange="onSlideChange"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        }"
        @swiper="onSwiper"
        class="tw-w-full tw-max-w-xl lg:tw-max-w-full"
      >
        <SwiperSlide v-for="(blog, index) in blogs" :key="`blog-${index}`" class="!tw-flex !tw-h-auto">
          <lazy-theme5-blogs-blog-card :blog="blog" :index="index" />
        </SwiperSlide>

        <div class="controls xl:!tw-hidden">
          <div
            class="slide-left-arrow w-slider-arrow-left"
            :isDisabled="!canPaginateBack"
            @click="() => swiper.slidePrev()"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
                fill="#6EADAB"
              />
            </svg>
            <div class="slide-circle slider-circle-transform"></div>
          </div>

          <div
            class="slide-right-arrow w-slider-arrow-right"
            :isDisabled="!canPaginateNext"
            @click="() => swiper.slideNext()"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
                fill="#6EADAB"
              />
            </svg>
            <div class="slide-circle right"></div>
          </div>
        </div>
      </Swiper>
    </div>
    <div class="tw-pt-7 lg:tw-hidden">
      <nuxt-link :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">{{ vars.buttonLabelText }}</nuxt-link>
    </div>
  </section>

  <section
    v-else-if="variants.v2 === variant && sidebarComponents.length === 0"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-mb-6 tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center lg:tw-mb-12 xl:tw-mb-6">
      <div
        class="tw-flex tw-flex-wrap tw-justify-center tw-text-center tw-text-black xl:tw-gap-4"
        v-html="vars.titleHtml"
      ></div>
    </div>
    <div class="tw-mb-12 tw-hidden tw-justify-center xl:tw-flex" v-if="vars.buttonLinkUrl">
      <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>

    <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-gap-x-10 tw-gap-y-5 xl:tw-flex-col-reverse">
      <MotionGroup
        :preset="vars.animationText ? vars.animationText : 'fadeVisible'"
        class="tw-w-full lg:tw-max-w-full"
        :duration="800"
        is="div"
      >
        <Swiper
          :modules="[SwiperPagination]"
          :pagination="false"
          :slides-per-view="1"
          :space-between="10"
          effect="fade"
          :clickable="true"
          :watch-overflow="true"
          @slideChange="onSlideChange"
          :breakpoints="{
            320: { slidesPerView: 1, spaceBetween: 20 },
            1024: { slidesPerView: 2, spaceBetween: 24 },
            1280: { slidesPerView: 3, spaceBetween: 24 },
          }"
          @swiper="onSwiper"
          class="tw-w-full lg:tw-max-w-full"
        >
          <SwiperSlide v-for="(blog, index) in blogs" :key="`blog-${index}`">
            <lazy-theme5-blogs-blog-card :blog="blog" :index="index" version="v2" />
          </SwiperSlide>
        </Swiper>
      </MotionGroup>

      <div class="tw-mt-4 xl:tw-hidden">
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v6"
          :canPaginateBack="canPaginateBack"
          :canPaginateNext="canPaginateNext"
        />
      </div>

      <nuxt-link
        v-if="vars.buttonLinkUrl"
        :to="vars.buttonLinkUrl"
        :external="true"
        :class="`n-${vars.buttonTypeText} tw-mt-4 xl:tw-mt-0 xl:tw-hidden`"
      >
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>
  </section>

  <section
    v-else-if="variants.v3 === variant && sidebarComponents.length === 0"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-center tw-gap-5 md:tw-flex-row">
      <div class="tw-mb-6 tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-center lg:tw-mb-12 xl:tw-mb-6">
        <h2 class="n-title-primary">{{ vars.titleText }}</h2>
      </div>
      <div class="r tw-mb-12" v-if="vars.buttonLinkUrl">
        <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">
          {{ vars.buttonLabelText }}
        </nuxt-link>
      </div>
    </div>

    <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-gap-x-10 tw-gap-y-5 xl:tw-flex-col-reverse">
      <MotionGroup
        :preset="vars.animationText ? vars.animationText : 'fadeVisible'"
        class="tw-w-full lg:tw-max-w-full"
        :duration="800"
        is="div"
      >
        <Swiper
          :modules="[SwiperPagination]"
          :pagination="false"
          :slides-per-view="1"
          :space-between="10"
          effect="fade"
          :clickable="true"
          :watch-overflow="true"
          @slideChange="onSlideChange"
          :breakpoints="{
            320: { slidesPerView: 1, spaceBetween: 20 },
            1024: { slidesPerView: 2, spaceBetween: 24 },
            1280: { slidesPerView: 3, spaceBetween: 24 },
          }"
          @swiper="onSwiper"
          class="tw-w-full lg:tw-max-w-full"
        >
          <SwiperSlide v-for="(blog, index) in blogs" :key="`blog-${index}`">
            <lazy-theme5-blogs-blog-card :blog="blog" :index="index" version="v3" />
          </SwiperSlide>
        </Swiper>
      </MotionGroup>

      <div class="controls xl:!tw-hidden">
        <div
          data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
          class="slide-left-arrow w-slider-arrow-left"
          :isDisabled="!canPaginateBack"
          @click="() => swiper.slidePrev()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
              fill="#6EADAB"
            />
          </svg>
          <div class="slide-circle slider-circle-transform"></div>
        </div>
        <div
          data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
          class="slide-right-arrow w-slider-arrow-right"
          :isDisabled="!canPaginateNext"
          @click="() => swiper.slideNext()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
              fill="#6EADAB"
            />
          </svg>
          <div class="slide-circle right"></div>
        </div>
      </div>
    </div>
  </section>

  <div
    v-else-if="variants.v2 === variant && sidebarComponents.length > 0"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded)`"
    class="tw-p-6"
  >
    <div class="tw-mb-6 tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-start">
      <div class="tw-flex tw-flex-wrap tw-justify-center tw-text-start tw-text-black" v-html="vars.titleHtml"></div>
    </div>
    <div class="tw-mb-12 tw-justify-center" v-if="vars.buttonLinkUrl">
      <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>

    <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-gap-x-10 tw-gap-y-5">
      <MotionGroup
        :preset="vars.animationText ? vars.animationText : 'fadeVisible'"
        class="tw-w-full"
        style="border-radius: var(--rounded)"
        :duration="800"
        is="div"
      >
        <Swiper
          :modules="[SwiperPagination]"
          :pagination="false"
          :slides-per-view="1"
          :space-between="10"
          effect="fade"
          :clickable="true"
          :watch-overflow="true"
          @slideChange="onSlideChange"
          @swiper="onSwiper"
          class="tw-w-full"
        >
          <SwiperSlide v-for="(blog, index) in blogs" :key="`blog-${index}`">
            <lazy-theme5-blogs-blog-card :blog="blog" :index="index" version="v2" :sidebar-component="true" />
          </SwiperSlide>
        </Swiper>
      </MotionGroup>

      <div class="tw-mt-4">
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v6"
          :canPaginateBack="canPaginateBack"
          :canPaginateNext="canPaginateNext"
        />
      </div>

      <nuxt-link v-if="vars.buttonLinkUrl" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText} tw-mt-4`">
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts">
import type { Component } from '~/types';
import Loader from '~/components/common/Loader.vue';
import NotFound from '~/components/theme2/base/NotFound.vue';
import indexGlobal from '~/mixins/index.global';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import SearchBox from '~/components/common/SearchBox.vue';
import { ROUTES } from '~/constants/ui.constants';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'Theme5BlogSection',

  mixins: [BlogsMixin, indexGlobal, ComponentMixin],

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchBlogsInPage(props.component);
  },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
    };
  },

  computed: {
    ROUTES() {
      return ROUTES;
    },

    ...mapState(useWebsiteStore, ['sidebarComponents']),
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },

  mounted() {
    this.onSlideChange();
  },
});
</script>
